import {
  GET_SITE_OWNER_NOTIFICATION_LIST_FAILURE,
  GET_SITE_OWNER_NOTIFICATION_LIST_REQUEST,
  GET_SITE_OWNER_NOTIFICATION_LIST_SUCCESS,
  CLEAR_OWNER_NOTIFICATION,
  GET_OWNER_NOTIFICATION_REQUEST,
  GET_OWNER_NOTIFICATION_SUCCESS,
  GET_OWNER_NOTIFICATION_FAILURE,
  GET_OWNER_NOTIFICATION_TEMPLATE_LIST_REQUEST,
  GET_OWNER_NOTIFICATION_TEMPLATE_LIST_SUCCESS,
  GET_OWNER_NOTIFICATION_TEMPLATE_LIST_FAILURE,
  CREATE_SITE_OWNER_NOTIFICATION_REQUEST,
  CREATE_SITE_OWNER_NOTIFICATION_FAILURE,
  CREATE_SITE_OWNER_NOTIFICATION_SUCCESS,
  GET_GLOBAL_OWNER_NOTIFICATION_LIST_REQUEST,
  GET_GLOBAL_OWNER_NOTIFICATION_LIST_SUCCESS,
  GET_GLOBAL_OWNER_NOTIFICATION_LIST_FAILURE,
  GET_OWNER_NOTIFICATION_TEMPLATE_REQUEST,
  GET_OWNER_NOTIFICATION_TEMPLATE_FAILURE,
  GET_OWNER_NOTIFICATION_TEMPLATE_SUCCESS,
  CLEAR_OWNER_NOTIFICATION_TEMPLATE,
  CREATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST,
  CREATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE,
  CREATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS,
  UPDATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST,
  UPDATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE,
  UPDATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS,
  DELETE_OWNER_NOTIFICATION_TEMPLATE_REQUEST,
  DELETE_OWNER_NOTIFICATION_TEMPLATE_FAILURE,
  DELETE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS,
} from "actions/ownerNotification";

const initialState = {
  loading: false,
  error: {},
  list: [],
  details: {},
  templateList: [],
  templateDetails: [],
  globalList: [],
  globalLoading: false,
};

export default function ownerNotification(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SITE_OWNER_NOTIFICATION_LIST_REQUEST:
    case GET_OWNER_NOTIFICATION_REQUEST:
    case CREATE_SITE_OWNER_NOTIFICATION_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SITE_OWNER_NOTIFICATION_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: payload,
      };
    }

    case GET_OWNER_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        details: payload,
      };
    }

    case CREATE_SITE_OWNER_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }

    case GET_SITE_OWNER_NOTIFICATION_LIST_FAILURE:
    case GET_OWNER_NOTIFICATION_FAILURE:
    case CREATE_SITE_OWNER_NOTIFICATION_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case GET_OWNER_NOTIFICATION_TEMPLATE_LIST_REQUEST:
    case GET_OWNER_NOTIFICATION_TEMPLATE_REQUEST:
    case CREATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST:
    case UPDATE_OWNER_NOTIFICATION_TEMPLATE_REQUEST:
    case DELETE_OWNER_NOTIFICATION_TEMPLATE_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_OWNER_NOTIFICATION_TEMPLATE_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        templateList: payload.map((it) => {
          return {
            ...it,
            label: it.name + (it.published ? "" : " (Unpublished)"),
            value: it.id,
          };
        }),
      };
    }

    case GET_OWNER_NOTIFICATION_TEMPLATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        templateDetails: payload,
      };
    }

    case CREATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS:
    case UPDATE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS:
    case DELETE_OWNER_NOTIFICATION_TEMPLATE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }

    case GET_OWNER_NOTIFICATION_TEMPLATE_LIST_FAILURE:
    case GET_OWNER_NOTIFICATION_TEMPLATE_FAILURE:
    case CREATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE:
    case UPDATE_OWNER_NOTIFICATION_TEMPLATE_FAILURE:
    case DELETE_OWNER_NOTIFICATION_TEMPLATE_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case GET_GLOBAL_OWNER_NOTIFICATION_LIST_REQUEST: {
      return {
        ...state,
        globalLoading: true,
      };
    }

    case GET_GLOBAL_OWNER_NOTIFICATION_LIST_SUCCESS: {
      return {
        ...state,
        globalLoading: false,
        globalList: payload,
      };
    }

    case GET_GLOBAL_OWNER_NOTIFICATION_LIST_FAILURE: {
      return {
        ...state,
        globalLoading: false,
      };
    }

    case CLEAR_OWNER_NOTIFICATION: {
      return {
        ...state,
        ...initialState,
      };
    }

    case CLEAR_OWNER_NOTIFICATION_TEMPLATE: {
      return {
        ...state,
        templateDetails: {},
      };
    }

    default:
      return state;
  }
}
